"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChangePassword = useChangePassword;
const react_1 = require("react");
/**
 * Hook for in-app password change (signed-in users updating their own
 * password — distinct from Cognito Hosted UI's "Forgot password" flow).
 *
 * The hook is a thin wrapper around the adapter's `changePassword` method;
 * it adds local in-flight state and error tracking so the UI doesn't have
 * to re-implement that wiring.
 *
 * @example
 *   const { changePassword, changing, error } = useChangePassword(sessionManager);
 *   const onSubmit = () => changePassword(oldPwd, newPwd);
 */
function useChangePassword(sessionManager) {
    const [changing, setChanging] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    const changePassword = (0, react_1.useCallback)((oldPassword, newPassword) => __awaiter(this, void 0, void 0, function* () {
        setChanging(true);
        setError(null);
        try {
            yield sessionManager
                .getAdapter()
                .changePassword(oldPassword, newPassword);
        }
        catch (e) {
            const err = e instanceof Error ? e : new Error(String(e));
            setError(err);
            throw err;
        }
        finally {
            setChanging(false);
        }
    }), [sessionManager]);
    return { changePassword, changing, error };
}
